import { useTranslation } from 'react-i18next';

import { Alert } from '@myphx-engineering/phx-design-system';

export const MaxAttemptsReachedError = () => {
    const { t } = useTranslation();
    return (
        <Alert data-testid="max-attempts-reached-error" severity="error">
            {t('formErrors.maxAttemptsReachedError.tryAgain')}
        </Alert>
    );
};
